import { Search } from 'lucide-react';

interface ConversationSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

/**
 * ConversationSearch - Campo de busca para conversas
 */
export const ConversationSearch = ({
  value,
  onChange,
  placeholder = 'Buscar conversas...'
}: ConversationSearchProps) => {
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#666666]" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="
          w-full pl-10 pr-4 py-2.5
          bg-[#1a1a1a] border border-[#333333] rounded-lg
          text-white text-sm placeholder:text-[#666666]
          focus:outline-none focus:border-[#F4CC04]
          transition-colors
        "
      />
    </div>
  );
};
